import React from 'react';
import './rain.css';
import { ChartComponent, Inject, DateTime, SeriesCollectionDirective, SeriesDirective, ColumnSeries, Tooltip, DataLabel, AreaSeries, Category, AxisModel, ChartAnnotation, MarginModel }  from '@syncfusion/ej2-react-charts';
import Constants from '../../models/constants';
import Weather from '../../models/weather';

let marginModel: MarginModel = {
    top: 10,
    bottom: 0
};

let primaryXAxis: AxisModel = {
    valueType: 'DateTime',
    visible: true,
    labelFormat: ' ',
    interval: 1,
    intervalType: 'Days',
    majorGridLines: {
        width: 0.5,
        color: 'grey'
    },
    majorTickLines: {
        height: 0
    },
    edgeLabelPlacement: 'Shift'
};

class DailyRain {
    date: string = '';
    rain: number = 0;
}

const Rain: React.FC<{weather: Weather}> = ({weather}) => {
    let data: DailyRain[] = [];
    let today: Date = new Date();
    let rainfall = weather.last30days.rainfall.reverse();
    for (let i = 0; i < rainfall.length; i++) {
        let currentDate = new Date(today.getTime() - (i) * 24 * 60 * 60 * 1000);
        let formattedDate = currentDate.toDateString();
        let rain = rainfall[i];
        data.push({ date: formattedDate, rain: rain });
    }
    data = data.reverse();
    console.log(data)
    const startDate: string = `${data[0].date.split(' ')[1]} ${data[0].date.split(' ')[2]}`;
    const last30daysRailFall: number = weather.last30days?.rainfall?.reduce((a: number, c: number) => a + c) ?? 0;
    const last30daysRailFallStr: string = (last30daysRailFall ?? 0).toFixed(0);
    const last7daysRailFall: number = weather.last30days?.rainfall.slice(0, 7).reduce((a: number, c: number) => a + c) ?? 0;
    const last7daysRailFallStr: string = (last7daysRailFall ?? 0).toFixed(0);
    const since9amRailFall: number = weather.since9am?.rainfall ?? 0;
    const since9amRailFallStr: string = since9amRailFall.toFixed(1);
    const maxRainFall: number = weather.last30days?.rainfall?.reduce((a: number, b: number) => a > b ? a : b) ?? 200 - 20;
    const topRailFall: number = Math.round(maxRainFall + 20);
    let primaryYAxis: AxisModel = {
        valueType: 'Double',
        maximum: topRailFall,
        interval: 1,
        visible: false,
        majorTickLines: {
            height: 0
        },
        labelFormat: '{value}mm',
        edgeLabelPlacement: 'Shift',
        labelPosition: 'Outside',
        placeNextToAxisLine: true
    };
    return (
        
        <div className="rain-container">
            <div className='rain-title'>
                Rain
            </div>
            <div className='rain-max-text'>
                {topRailFall} mm
            </div>
            <ChartComponent 
                className="rain-component" 
                background={Constants.grey} 
                palettes={[Constants.lightBlue]} 
                primaryXAxis={primaryXAxis}
                primaryYAxis={primaryYAxis}
                margin={marginModel}
                chartArea={{ border: { width: 0 } }}>
                <Inject services={[ColumnSeries, Tooltip, DataLabel, AreaSeries, Category, DateTime, ChartAnnotation]} />
                <SeriesCollectionDirective>
                    <SeriesDirective dataSource={data} xName='date' yName='rain' name='Rain' type='Area' />
                </SeriesCollectionDirective>
            </ChartComponent>
            <div className='rain-text-container'>
                <div className='rain-label-container'>
                    <span className='rain-label'>{startDate}</span>
                    <span className='rain-label'>Today</span>
                </div>
                <div className='rain-sum-container'>
                    <span className='rain-sum'>
                        <span className='large-text'>
                            {last30daysRailFallStr}
                        </span>
                        <span className='big-text'>
                            mm Last 30 Days
                        </span>
                    </span>
                    <span className='rain-sum'>
                        <span className='large-text'>
                            {last7daysRailFallStr}
                        </span>
                        <span className='big-text'>
                            mm Last 7 Days
                        </span>
                    </span>
                    <span className='rain-sum'>
                        <span className='large-text'>
                            {since9amRailFallStr}
                        </span>
                        <span className='big-text'>
                            mm Since 9am
                        </span>
                    </span>
                </div>
            </div>
        </div>
    );
} 

export default Rain;